import React from 'react';

import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

function Link({ to, children, tag: TagName = 'div', preNavigationCallback, ...rest }) {
  const navigate = useNavigate();

  const handleClick = e => {
    e.preventDefault();

    preNavigationCallback?.();

    if (!to) return;

    navigate(to);
  };

  return (
    <TagName role="link" onClick={handleClick} {...rest}>
      {children}
    </TagName>
  );
}

Link.propTypes = {
  to: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  preNavigationCallback: PropTypes.func,
  tag: PropTypes.string,
};

export default Link;
